var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53125 1.63468L9.96484 2.10343L10.4336 1.63546C11.7422 0.360069 13.5547 -0.220399 15.3359 0.0760849C18.0273 0.524522 20 2.85343 20 5.5839V5.81046C20 7.43155 19.3281 8.98233 18.1406 10.0878L11.082 16.6776C10.7891 16.9511 10.4023 17.1034 10 17.1034C9.59766 17.1034 9.21094 16.9511 8.91797 16.6776L1.85898 10.0878C0.673047 8.98233 0 7.43155 0 5.81046V5.5839C0 2.85343 1.97344 0.524522 4.66406 0.0760849C6.41016 -0.220399 8.25781 0.360069 9.53125 1.63468C9.53125 1.63507 9.49609 1.63468 9.53125 1.63468ZM9.96484 4.75577L8.20703 2.92765C7.35938 2.11437 6.15625 1.72843 4.97266 1.9253C3.18555 2.22335 1.875 3.7714 1.875 5.5839V5.81046C1.875 6.91202 2.33242 7.96671 3.13828 8.71671L10 15.123L16.8633 8.71671C17.668 7.96671 18.125 6.91202 18.125 5.81046V5.5839C18.125 3.7714 16.8125 2.22335 15.0273 1.9253C13.8438 1.72843 12.6406 2.11437 11.793 2.92765L9.96484 4.75577Z",
    fill: "#CB8D8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/Wishlist.0992217a193435a2d024690c768f61c9.svg";
export { ForwardRef as ReactComponent };